var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHelpTutorials(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 23.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#bdccd4;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-help-tutorials") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.73,3.16v14H25.27v-14ZM30,21.11H0v1a1,1,0,0,0,1,1H29a1,1,0,0,0,1-1ZM17.58,10.57,14.2,12.78a.49.49,0,0,1-.74-.4V8a.49.49,0,0,1,.79-.38l3.34,2.19A.48.48,0,0,1,17.58,10.57Zm8.55,7.82H3.87a.49.49,0,0,1-.49-.49V2.42a.48.48,0,0,1,.49-.49H26.13a.48.48,0,0,1,.47.49V17.9A.49.49,0,0,1,26.13,18.39ZM25.77,0H4.21A2.77,2.77,0,0,0,1.45,2.76V19.84a.49.49,0,0,0,.49.49H28.07a.49.49,0,0,0,.47-.49V2.76A2.76,2.76,0,0,0,25.77,0ZM9.67,10.16A5.33,5.33,0,1,1,15,15.48,5.32,5.32,0,0,1,9.67,10.16Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHelpTutorials);
export default __webpack_public_path__ + "static/media/icon-help-tutorials.09f744752d24263ce5611a051d3f16b4.svg";
export { ForwardRef as ReactComponent };